/* global IntersectionObserver */ function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
import React, { PureComponent } from "react";
import classNames from "classnames";
import { HtmlEditor } from "@aeaton/react-prosemirror";
import { Schema } from "prosemirror-model";
import PropTypes from "prop-types";
import { toggleMark, baseKeymap, joinUp, joinDown, lift, selectParentNode, chainCommands, exitCode } from "prosemirror-commands";
import { undo, redo, history } from "prosemirror-history";
import { getMentionsPlugin } from "prosemirror-mentions";
import { keymap } from "prosemirror-keymap";
import { undoInputRule } from "prosemirror-inputrules";
import { gapCursor } from "prosemirror-gapcursor";
import "prosemirror-gapcursor/style/gapcursor.css";
import Icon from "./Icon";
var markActive = function(type) {
    return function(state) {
        var _state_selection = state.selection, from = _state_selection.from, $from = _state_selection.$from, to = _state_selection.to, empty = _state_selection.empty;
        return empty && type ? type.isInSet(state.storedMarks || $from.marks()) : state.doc.rangeHasMark(from, to, type);
    };
};
var schema = new Schema({
    nodes: {
        doc: {
            content: "block+"
        },
        paragraph: {
            content: "inline*",
            group: "block",
            parseDOM: [
                {
                    tag: "p"
                }
            ],
            toDOM: function() {
                return [
                    "p",
                    0
                ];
            }
        },
        text: {
            group: "inline"
        },
        hard_break: {
            inline: true,
            group: "inline",
            selectable: false,
            parseDOM: [
                {
                    tag: "br"
                }
            ],
            toDOM: function() {
                return [
                    "br"
                ];
            }
        },
        mention: {
            group: "inline",
            inline: true,
            atom: true,
            selectable: false,
            draggable: false,
            attrs: {
                id: "",
                href: {
                    default: "#"
                },
                name: ""
            },
            // INFO: this is also called when creating a new note; whatever default text
            // is passed to the component is parsed here and then fed to toDOM, which
            // converts it into the proper DOM.
            parseDOM: [
                {
                    tag: "a[data-node-ref]",
                    getAttrs: function getAttrs(dom) {
                        return {
                            href: dom.getAttribute("href"),
                            title: dom.getAttribute("title"),
                            id: parseInt(dom.getAttribute("data-node-ref"), 10) || 0,
                            name: dom.innerText
                        };
                    }
                }
            ],
            toDOM: function(node) {
                return [
                    "a",
                    {
                        class: "social-activity__mention icon-photos icon-photos--white",
                        "data-node-ref": node.attrs.id,
                        href: "#"
                    },
                    node.attrs.name || 0
                ];
            }
        }
    },
    marks: {
        link: {
            attrs: {
                href: {},
                title: {
                    default: null
                }
            },
            inclusive: false,
            parseDOM: [
                {
                    tag: "a:not([data-node-ref])",
                    getAttrs: function getAttrs(dom) {
                        return {
                            href: dom.getAttribute("href"),
                            title: dom.getAttribute("title")
                        };
                    }
                }
            ],
            toDOM: function toDOM(node) {
                var _node_attrs = node.attrs, href = _node_attrs.href, title = _node_attrs.title;
                return [
                    "a",
                    {
                        href: href,
                        title: title
                    },
                    0
                ];
            }
        },
        // :: MarkSpec An emphasis mark. Rendered as an `<em>` element.
        // Has parse rules that also match `<i>` and `font-style: italic`.
        em: {
            parseDOM: [
                {
                    tag: "i"
                },
                {
                    tag: "em"
                },
                {
                    style: "font-style=italic"
                }
            ],
            toDOM: function() {
                return [
                    "em",
                    0
                ];
            }
        },
        // :: MarkSpec A strong mark. Rendered as `<strong>`, parse rules
        // also match `<b>` and `font-weight: bold`.
        strong: {
            parseDOM: [
                {
                    tag: "strong"
                },
                // This works around a Google Docs misbehavior where
                // pasted content will be inexplicably wrapped in `<b>`
                // tags with a font-weight normal.
                {
                    tag: "b",
                    getAttrs: function(node) {
                        return node.style.fontWeight !== "normal" && null;
                    }
                },
                {
                    style: "font-weight",
                    getAttrs: function(value) {
                        return /^(bold(er)?|[5-9]\d{2,})$/.test(value) && null;
                    }
                }
            ],
            toDOM: function() {
                return [
                    "strong",
                    0
                ];
            }
        },
        underline: {
            parseDOM: [
                {
                    tag: "u"
                },
                {
                    style: "text-decoration=underline"
                }
            ],
            toDOM: function() {
                return [
                    "span",
                    {
                        style: "text-decoration:underline"
                    }
                ];
            }
        }
    }
});
export var insertBreak = function(state, dispatch) {
    var br = schema.nodes.hard_break.create();
    dispatch(state.tr.replaceSelectionWith(br).scrollIntoView());
    return true;
};
var keys = {
    "Mod-z": undo,
    "Shift-Mod-z": redo,
    Backspace: undoInputRule,
    "Mod-y": redo,
    "Alt-ArrowUp": joinUp,
    "Alt-ArrowDown": joinDown,
    "Mod-BracketLeft": lift,
    "Mod-b": toggleMark(schema.marks.strong),
    "Mod-i": toggleMark(schema.marks.em),
    "Mod-u": toggleMark(schema.marks.underline),
    Escape: selectParentNode,
    "Mod-Enter": chainCommands(exitCode, insertBreak),
    "Shift-Enter": chainCommands(exitCode, insertBreak),
    "Ctrl-Enter": chainCommands(exitCode, insertBreak)
};
Object.keys(baseKeymap).forEach(function(key) {
    if (keys[key]) {
        keys[key] = chainCommands(keys[key], baseKeymap[key]);
    } else {
        keys[key] = baseKeymap[key];
    }
});
var menu = [
    {
        id: "bold",
        title: "Toggle strong",
        iconName: "editor-bold",
        label: "Strong",
        isActive: markActive(schema.marks.strong),
        run: toggleMark(schema.marks.strong)
    },
    {
        id: "em",
        title: "Toggle emphasis",
        iconName: "editor-italic",
        label: "Emphasis",
        isActive: markActive(schema.marks.em),
        run: toggleMark(schema.marks.em)
    },
    {
        id: "underline",
        title: "Toggle underline",
        label: "Underline",
        iconName: "editor-underline",
        isActive: markActive(schema.marks.underline),
        run: toggleMark(schema.marks.underline)
    }
];
var MyToolButton = function(param) {
    var iconName = param.iconName, run = param.run, isActive = param.isActive, label = param.label, onMouseDown = param.onMouseDown, title = param.title, view = param.view;
    return /*#__PURE__*/ React.createElement("button", {
        title: title || label,
        className: classNames("rte-tools__btn", {
            "rte-tools__btn--active": isActive(view.state)
        }),
        onClick: function() {
            return run(view.state, view.dispatch);
        },
        onMouseDown: onMouseDown
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: iconName,
        size: "s"
    }), /*#__PURE__*/ React.createElement("span", {
        className: "sr-only"
    }, label));
};
var getSuggestionsHTML = function(items) {
    return '<div class="suggestion-item-list" style="z-index: 100000">'.concat(items.map(function(i) {
        return '<div class="suggestion-item">' + i.name + "</div>";
    }).join(""), "</div>");
};
var RichtextEditor = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(RichtextEditor, PureComponent);
    var _super = _createSuper(RichtextEditor);
    function RichtextEditor(props) {
        _classCallCheck(this, RichtextEditor);
        var _this;
        _this = _super.call(this, props);
        _defineProperty(_assertThisInitialized(_this), "removeMentionsList", function() {
            var mlist = document.querySelector(".suggestion-item-list");
            if (mlist) {
                mlist.remove();
            }
        });
        _this.state = {
            plugins: []
        };
        _this.ref = /*#__PURE__*/ React.createRef();
        return _this;
    }
    _createClass(RichtextEditor, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if ("IntersectionObserver" in window) {
                    this.observer = new IntersectionObserver(this.removeMentionsList, {
                        root: document.querySelector(".book-wrapper"),
                        rootMargin: "0px"
                    });
                    this.observer.observe(this.ref.current);
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.observer) {
                    this.observer.disconnect();
                }
                this.removeMentionsList();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this_props = this.props, disabled = _this_props.disabled, onChange = _this_props.onChange, text = _this_props.text;
                var plugins = [
                    history(),
                    gapCursor(),
                    getMentionsPlugin({
                        getSuggestions: function(type, text, done) {
                            type === "mention" && done(_this.props.mentions.filter(function(m) {
                                return m.name.toLowerCase().includes(text.toLowerCase());
                            }));
                        },
                        getSuggestionsHTML: function(items, type) {
                            if (type === "mention") {
                                return getSuggestionsHTML(items);
                            }
                        },
                        allowSpace: true,
                        maxNoOfSuggestions: 500,
                        delay: 300,
                        activeClass: "suggestion-item--active"
                    }),
                    keymap(keys)
                ];
                return /*#__PURE__*/ React.createElement("div", {
                    className: "rte",
                    ref: this.ref
                }, /*#__PURE__*/ React.createElement(HtmlEditor, {
                    options: {
                        schema: schema,
                        plugins: plugins,
                        editable: function() {
                            return !disabled;
                        }
                    },
                    value: text,
                    onChange: onChange,
                    render: function(param) {
                        var editor = param.editor, view = param.view;
                        _this.editor = editor;
                        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
                            className: "rte__tools"
                        }, menu.map(function(button) {
                            return /*#__PURE__*/ React.createElement(MyToolButton, _extends({}, button, {
                                view: view,
                                key: button.id
                            }));
                        }), _this.props.extraButtons.length && _this.props.extraButtons.map(function(Btn, i) {
                            return /*#__PURE__*/ React.createElement(Btn, {
                                key: "ebtn".concat(i)
                            });
                        })), /*#__PURE__*/ React.createElement("div", {
                            className: "rte__wrapper",
                            style: {
                                pointerEvents: disabled ? "none" : "all",
                                opacity: disabled ? 0.65 : 1
                            }
                        }, editor));
                    }
                }));
            }
        }
    ]);
    return RichtextEditor;
}(PureComponent);
RichtextEditor.propTypes = {
    disabled: PropTypes.bool,
    mentions: PropTypes.array.isRequired,
    text: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    extraButtons: PropTypes.array
};
RichtextEditor.defaultProps = {
    extraButtons: []
};
export default RichtextEditor;
